(function () {
  /**
   * @awaitingdeprecation
   *
   * @ngdoc service/provider
   * @name jilOrganizationsContractOffers
   * @description defines service to manage jil organizations contract offers resources
   */
  angular
    .module('binky.core.api.jil')
    .provider('jilOrganizationsContractOffers', jilOrganizationsContractOffersProvider);

  let url;

  /* @ngInject */
  function jilOrganizationsContractOffersProvider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/organizations`;
    }

    /* @ngInject */
    function $get($resource, apiUtils) {
      const service = {
        offers: getOffersResource(),
      };

      return service;

      ///////////

      function getOffersResource() {
        return $resource(`${url}/:orgId/contracts/:contractId/offers/`, {
          contractId: '@contractId',
          mode: '@mode',
          orgId: apiUtils.getActiveOrg,
        });
      }
    }
  }
})();
